export enum FecJournalType {
  Purchase = 'purchase',
  Sales = 'sales',
  Bank = 'bank',
  Cash = 'cash',
  Payroll = 'payroll',
  Od = 'od',
  Other = 'other',
  Opening = 'opening',
}

export const FEC_JOURNAL_TYPES = [
  FecJournalType.Purchase,
  FecJournalType.Sales,
  FecJournalType.Bank,
  FecJournalType.Cash,
  FecJournalType.Payroll,
  FecJournalType.Od,
  FecJournalType.Other,
  FecJournalType.Opening,
] as const

export const isFecJournalTypeWithLinkedAccount = (type: FecJournalType): boolean =>
  type === FecJournalType.Bank || type === FecJournalType.Cash
